$(document).ready(function() {

    var notfallboxIds = $.cookie('notfallbox');
    if (notfallboxIds == null) {
        notfallboxIds = "";
    }
    var notfallboxIdsArray = notfallboxIds.split(",");
    if (notfallboxIdsArray.length > 0) {
        $.each(notfallboxIdsArray, function(index, value) {
            if ($('.notFallBox').data('notfallbox_id') == value) {
                $('.notFallBox').hide();
            }
        });
    }

});

function checkIfNotFallBoxIdIsUnique(notFallBoxIds, newId) {

    notFallBoxIds = notFallBoxIds + "," + newId;
    var nArray = notFallBoxIds.split(",");
    uniqueArray = $.unique(nArray);
    return uniqueArray.join(",");

}

function closeFromNotFallBox(notFallBoxId) {

    var storedNotFallBoxes = $.cookie('notfallbox');
    if (storedNotFallBoxes == null) {
        storedNotFallBoxes = "";
    }

    if (storedNotFallBoxes) {
        storedNotFallBoxes = checkIfNotFallBoxIdIsUnique(storedNotFallBoxes, notFallBoxId);
    } else {
        storedNotFallBoxes = notFallBoxId;
    }

    $.cookie('notfallbox', storedNotFallBoxes, {
        expires: 1,
        path: '/'
    });

    $(".notFallBox").fadeOut();

}